module.exports = __webpack_public_path__ + "static/ekigo-c99610713ed99e5dc952dfc5d08a3664.jpg";